export default "__VITE_ASSET__qarAmN5a__"